import React from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { Button, Row, Col } from 'reactstrap'

import { getProfile } from '../store/reducers'
import { renderField } from 'core/utils/form'

const propTypes = {
  onSubmit: PropTypes.func.isRequired
}

const validate = values => {
  const errors = {}
  if (!values.first_name) { errors.first_name = 'Required' }
  if (!values.last_name) { errors.last_name = 'Required' }
  if (!values.email) { errors.email = 'Required' }
  return errors
}

class ProfileForm extends React.Component {

  render() {
    const { error, handleSubmit, invalid, submitting } = this.props

    return (
      <Row>
        <Col md={{size: 6, offset: 3}}>
          <form onSubmit={handleSubmit}>
            <Field name="first_name" error={error} component={renderField} type="text" label="First Name" />
            <Field name="last_name" error={error} component={renderField} type="text" label="Last Name" />
            <Field name="email" error={error} component={renderField} type="email" label="Email" />
            <Button color="primary" disabled={invalid || submitting}>Update</Button>
          </form>
        </Col>
      </Row>
    )
  }
}

ProfileForm.propTypes = propTypes

ProfileForm = reduxForm({
  form: 'profileEdit',
  validate
})(ProfileForm)

const mapStateToProps = state => ({
  initialValues: getProfile(state)
})

export default connect(mapStateToProps)(ProfileForm)



// WEBPACK FOOTER //
// ./src/features/Settings/profile/ProfileForm/index.jsx